import injectScript from './injectScript';
export default injectScript;